import { render, staticRenderFns } from "./ReportCommissionsTable.vue?vue&type=template&id=aa1c5a20&scoped=true&"
import script from "./ReportCommissionsTable.vue?vue&type=script&lang=js&"
export * from "./ReportCommissionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1c5a20",
  null
  
)

export default component.exports